// Module
var code = "<div> <h5 class=\"text-muted uppercase\"><strong>{{heading}}</strong></h5> <form ng-submit=\"search(q)\"> <input type=\"text\" class=\"form-control\" ng-model=\"q\"/> </form> </div> ";
// Exports
module.exports = code;